import React from "react"
import Relay from "react-relay"
import { browserHistory } from "react-router"
import smoothScroll from "../../scripts/smoothScroll"
import ThumbnailGridItem from "./ThumbnailGridItem"

class RelatedItem extends React.Component {
  _handleClick = e => {
    e.preventDefault()

    browserHistory.push("/item/" + this.props.resource.id)

    smoothScroll(document.getElementById("main"))
  }

  render() {
    return (
      <ThumbnailGridItem
        resource={this.props.resource}
        onClick={this._handleClick}
      />
    )
  }
}

export default Relay.createContainer(RelatedItem, {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        ${ThumbnailGridItem.getFragment("resource")}
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/modules/RelatedItem.js